export default {
  default: () => import("/home/runner/work/wdd/wdd/frontend/ubs/layouts/default.vue").then(m => m.default || m),
  registration: () => import("/home/runner/work/wdd/wdd/frontend/ubs/layouts/registration.vue").then(m => m.default || m),
  results: () => import("/home/runner/work/wdd/wdd/frontend/ubs/layouts/results.vue").then(m => m.default || m),
  video: () => import("/home/runner/work/wdd/wdd/frontend/ubs/layouts/video.vue").then(m => m.default || m)
}